// Pure helper to remap server-side field errors into a form-friendly shape.
// Keeps behaviour deterministic and safe by accumulating unique messages per
// field in a Set and joining them with a clear delimiter for display.
export function remapServerFieldErrors(fieldErrors: Record<string, string>): Record<string, string> {
  const messageSets: Record<string, Set<string>> = {};

  const addMessage = (key: string, msg: string) => {
    if (!messageSets[key]) messageSets[key] = new Set();
    messageSets[key].add(msg);
  };

  for (const [field, message] of Object.entries(fieldErrors)) {
    if (field === 'name' || field === 'description') {
      addMessage(field, message);
    } else {
      // Unknown fields map to the `name` field by convention
      addMessage('name', message);
    }
  }

  const result: Record<string, string> = {};
  for (const [k, set] of Object.entries(messageSets)) {
    result[k] = Array.from(set).join('; ');
  }

  return result;
}
